import { FC } from "react";

import { Stack } from "@mui/material";

import { BaseFormV2Step1Layout, BaseFormV2Step1LayoutProps } from "./BaseFormV2Step1Layout";

import { useMediaQuery } from "@/hooks/useMediaQuery";

export type AuctionV2Step1LayoutProps = Omit<BaseFormV2Step1LayoutProps, "slots"> & {
  additionalDonationPosition: "top-of-page" | "default";
  slots: {
    banner: React.ReactNode;
    organizationLogo: React.ReactNode;
    summary: React.ReactNode;
    welcomeBack: React.ReactNode;
    additionalDonation: React.ReactNode;
    rates: React.ReactNode;
    generateReceipt: React.ReactNode;
    zeffyBusinessModel: React.ReactNode;
    checkoutFooter: React.ReactNode;
  };
};

export const AuctionV2Step1Layout: FC<AuctionV2Step1LayoutProps> = ({
  slots,
  additionalDonationPosition = "default",
  ...rest
}) => {
  const { isSmallScreen } = useMediaQuery();

  return (
    <BaseFormV2Step1Layout
      {...rest}
      slots={{
        banner: slots.banner,
        info: (
          <Stack alignItems="flex-start" width="100%" gap={2}>
            {!isSmallScreen && slots.organizationLogo}
            {slots.summary}
          </Stack>
        ),
        order: (
          <Stack width="100%" gap={2}>
            {additionalDonationPosition === "top-of-page" && slots.additionalDonation}
            {slots.welcomeBack}
            {slots.rates}
            {additionalDonationPosition === "default" && slots.additionalDonation}
            <Stack width="100%" gap={1}>
              {slots.generateReceipt}
              {slots.zeffyBusinessModel}
            </Stack>
          </Stack>
        ),
        checkoutFooter: slots.checkoutFooter,
      }}
    />
  );
};
